import '../sass/index.scss';
// import { BaseView, BaseD3View } from './lib/base.js';
const $ = require('jquery');
// import each highchart (specs) and the library
const Highcharts = require('highcharts');

// let now = Date.UTC(2018, 6, 4);
// console.log(now)
import {chart1} from './chart1';
var highchart_theme = {chart:{backgroundColor:null,style:{fontFamily:'"Proxima Nova", "Helvetica", sans-serif',fontWeight:"normal"}},title:{style:{color:'#555',font:'18px "Proxima Nova", "Helvetica", sans-serif',align:'left'}},legend:{itemStyle:{font:'9pt "Proxima Nova", "Helvetica", sans-serif',color:'#555'},navigation:{enabled:!1}},lang:{thousandsSep:','},credits:{enabled:!1},exporting:{enabled:!1},plotOptions:{series:{marker:{enabled:!1}}}};Highcharts.setOptions(Highcharts.theme)

// three highcharts
Highcharts.setOptions( highchart_theme );
Highcharts.chart( 'highchart_container', chart1);


var obj = {
  b: (argument) => console.log(argument)
}

obj.b('hi'); // prints undefined, Window {...} (or the global object)
 // prints 10, Object {...}



// WEBPACK FOOTER //
// js/index.js